module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/home-6cf444f320751df6341e1e0bd93b99b8.svg";